<template>
  <v-card>
    <v-data-table
      flat
      :headers="headers"
      :items="GetVideosCategory"
      :expanded="expanded"
      @click:row="clickRow"
      :hide-default-header="true"
      :items-per-page="-1"
      :hide-default-footer="true" 
      style="background-color: #ecf1f2"
    >
      <template v-slot:body="props">
        <draggable :list="props.items" tag="tbody" @end="onDragEnd">
          <tr v-for="(projects, index) in props.items" :key="index">
            
            <td>{{ projects.Name }}</td>

            <td class="d-flex justify-end">
              <v-icon class="pa-0" @click="editItem(projects), (editdialog = true)">
                mdi-pencil
              </v-icon>
              <v-icon class="ml-3 mr-2" @click="Delete(projects)">
                mdi-delete-outline</v-icon
              >
            </td>
          </tr>
        </draggable>
      </template>
       </v-data-table>
    <!-----------------edit dialog-------------------------------->
    <v-dialog v-model="editdialog" width="500" persistent>
      <v-card>
        <div class="mx-5 py-5 d-flex justify-space-between">
          <h5>Edit Category</h5>
          <v-icon @click="editdialog = false">mdi-close</v-icon>
        </div>

        <div>
          <v-card color="#F6F8FC" flat class="px-3">
            <v-text-field v-model="editedItem.Name" required></v-text-field>
          </v-card>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="pa-3">
            <v-btn
              class="px-14 py-6 mb-2 text_trans"
              color="grey lighten-1"
              text
              @click="editdialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              class="px-14 py-6 mb-2 text_trans"
              :disabled="btnloader"
              @click="send()"
            >
              <span class="pa-4" v-if="btnloader != true"> Edit </span>
              <v-progress-circular
                indeterminate
                v-else
                size="20"
                class="px-5"
                color="white"
                v-show="btnloader"
              ></v-progress-circular>
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-----------------Delete dialog-------------------------------->
    <v-dialog v-model="dialogDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialogDelete = false">
            Cancel
          </v-btn>
          <v-btn color="primary" :disabled="btnloader" @click="DeleteItem">
            <span v-if="btnloader != true">Confirm</span>
            <v-progress-circular
              indeterminate
              v-else
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
// import costumicon from "../Video/costumicon.vue";
// import Costumicon2 from "../Video/costumicon2.vue";
import draggable from "vuedraggable";
import { mapGetters } from "vuex";
export default {
  name: "OrganizeComponent",
  //components: { costumicon, Costumicon2 },
  components: {
    draggable,
  },
  props: ["organizeDialog"],
  computed: {
    ...mapGetters(["GetVideosCategory"]),
  },
  data() {
    return {
      btnloader: false,
      dialog: false,
      dialogDelete: false,
      editdialog: false,
      expanded: [],
      headers: [
        {
          text: "Name",
          align: "left",
          value: "Id",
        },
        {
          text: "",
          align: "left",
          value: "Name",
        },
        { text: "", align: "right", value: "actions", sortable: false },
      ],
      projects: [
        {
          id: 1,
          name: "Anatomy and Physiology",
        },
        {
          id: 2,
          name: "AnimalTalk",
        },
        {
          id: 3,
          name: "BodyTalk Access",
        },
        {
          id: 4,
          name: "BodyTalk Courses",
        },
        {
          id: 5,
          name: "BreakThrough",
        },
        {
          id: 6,
          name: "CEUs",
        },
      ],
      peopleHeaders: [
        {
          text: "Text",
          align: "left",
          sortable: true,
          value: "text",
        },
      ],
      people: [
        {
          text: "Cortices",
        },
        {
          text: "Cortices How To",
        },
      ],
      editedItem: {
        Id: 0,
        Name: "",
      },
      editedIndex: -1,
      desserts: [
        {
          name: "Learn the BodyTalk Cortices Technique",
        },
      ],
    };
  },

  methods: {
    onDragEnd(event) {
      const movedItem = this.GetVideosCategory.splice(event.oldIndex, 1)[0];
      this.GetVideosCategory.splice(event.newIndex, 0, movedItem);
      var obj = {
        Id: movedItem.Id,
        sortNum: event.newIndex 
      }
      this.$store.dispatch("SortVideoCategory", obj).then((response) => {
        return response;
      }).catch((error) => {
        console.error("Error while saving the order:", error);
      });
    },
    clickRow(item, event) {
      if (event.isExpanded) {
        const index = this.expanded.findIndex((i) => i === item);
        this.expanded.splice(index, 1);
      } else {
        this.expanded.push(item);
      }
    },
    Delete(item) {
      this.deleteId = item.Id;
      this.dialogDelete = true;
    },
    DeleteItem() {
      this.btnloader=true;
      this.$store.dispatch("DeleteVideoCategory", this.deleteId).then(() => {
        this.dialogDelete = false;
        this.btnloader=false;
        this.close()
        this.$emit("fetchData");
        this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Deleted Successfully",
            showConfirmButton: false,
            timer: 2500,
          });
      });
    },
    send() {
      this.btnloader=true;
      this.$store.dispatch("UpdateVideoCategory", this.editedItem).then(() => {
        this.editdialog = false;
        this.btnloader=false;
        this.$emit("fetchData");
        this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Edited Successfully",
            showConfirmButton: false,
            timer: 2500,
          });
      });
    },
    editItem(item) {
      // this.editedIndex = this.desserts.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      this.editedItem.Name = item.Name;
      this.editedItem.Id = item.Id;
      this.dialog = true;
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
/* table.v-table tbody td {
    height: 40px;
    border: none;
}
.theme--light.v-table tbody tr:not(:last-child) {
    border-bottom: none;
}
table { border-collapse:collapse }
table td, table th {
  height: 40px; 
} */
</style>
